module.exports = __webpack_public_path__ + "static/media/White 24.b0af6a8e.svg";